import React from "react";
import DefaultHead from "../DefaultHead";

const phrases = [
  "What are you on about?",
  "Nothing to write home about.",
  "It's not about the destination, it's about the journey.",
  "Much ado about nothing.",
  "What's that all about?",
  "Just about enough.",
  "About face!",
  "What about you?",
  "What it's really about.",
];

const About: React.FC = () => {
  const phrase = phrases[Math.floor(Math.random() * phrases.length)];

  return (
    <div>
      <DefaultHead />
      <h1>About</h1>
      <p>{phrase}</p>
    </div>
  );
};

export default About;
